module.exports = __webpack_public_path__ + "img/bg_课堂教学.0ee2a6d8.png";